/* SON — badge "En stock" dans la recherche instantanee (menu deroulant).
   L'API JSON de Shopify ne renvoie pas les tags/collections : on injecte la
   liste des references en stock (window.SON_EN_STOCK, depuis la collection
   "Tapis en stock") et on badge les resultats correspondants des qu'ils
   apparaissent, via un MutationObserver. */
(function () {
  var LIST = window.SON_EN_STOCK || [];
  var STOCK = {};
  for (var i = 0; i < LIST.length; i++) { STOCK[LIST[i]] = 1; }
  if (LIST.length === 0) { return; }

  function handleFromHref(href) {
    if (!href) { return null; }
    var u = href.split('?')[0].split('#')[0];
    var idx = u.indexOf('/products/');
    if (idx < 0) { return null; }
    return u.slice(idx + 10).split('/')[0];
  }

  function makeBadge() {
    var s = document.createElement('span');
    s.className = 'son-stock-badge-mini';
    s.textContent = 'En stock';
    s.setAttribute('style', 'display:inline-block;margin-left:7px;vertical-align:middle;background:#fff;color:#1c1a18;border:1px solid #1c1a18;font-size:8px;letter-spacing:.06em;text-transform:uppercase;padding:2px 7px;border-radius:999px;line-height:1.3;font-weight:600;white-space:nowrap;');
    return s;
  }

  function scan() {
    var links = document.querySelectorAll('.predictive-search-wrapper a[href*="/products/"], [data-predictive-search] a[href*="/products/"], .predictive-search a[href*="/products/"]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (a.getAttribute('data-son-stock')) { continue; }
      var h = handleFromHref(a.getAttribute('href') || '');
      if (!h) { continue; }
      a.setAttribute('data-son-stock', STOCK[h] ? '1' : '0');
      if (STOCK[h] && !a.querySelector('.son-stock-badge-mini')) {
        var t = a.querySelector('.predictive-search__item-heading, [class*="heading"], [class*="title"], h3, h4, p, span');
        (t || a).appendChild(makeBadge());
      }
    }
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) { return; }
    scheduled = true;
    setTimeout(function () { scheduled = false; scan(); }, 50);
  }

  function start() {
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
    scan();
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
})();
